<template>
  <div>
    <b-row class="text-primary">
      <b-col>
        <h4 class="text-success text-center" v-if="tituloEditar">
          Editar Item Odontologico
        </h4>
        <b-card>
          <b-form @submit.prevent="submitForm">
            <div class="row">
              <div class="col-2">
                <span> Código</span>
                <b-form-input
                  id="codigo"
                  v-model="itemOdontologico.codigo"
                  type="text"
                  required
                />
              </div>
              <div class="col-10">
                <span> Descripcion del servicio odontologico</span>
                <b-form-textarea
                  id="descripcion"
                  v-model="itemOdontologico.descripcion"
                  rows="3"
                  type="text"
                  required
                />
              </div>
            </div>
            <hr />
            <span>Precios:</span>
            <div class="row mt-1">
              <div class="col">
                <span>Iess</span>
                <b-form-input
                  id="precIess1"
                  @keypress="soloNumeros"
                  v-model="itemOdontologico.precioJson.iess_n1"
                  type="float"
                  required
                ></b-form-input>
              </div>
              <div class="col">
                <span>Issfa Nivel 1</span>
                <b-form-input
                  id="precIssfa1"
                  @keypress="soloNumeros"
                  v-model="itemOdontologico.precioJson.issfa_n1"
                  type="float"
                  required
                ></b-form-input>
              </div>
              <div class="col">
                <span>Issfa Nivel 2</span>
                <b-form-input
                  id="precIssfa2"
                  @keypress="soloNumeros"
                  v-model="itemOdontologico.precioJson.issfa_n2"
                  type="float"
                  required
                ></b-form-input>
              </div>
              <div class="col">
                <span>Precio Isspol</span>
                <b-form-input
                  id="precIsspol1"
                  @keypress="soloNumeros"
                  v-model="itemOdontologico.precioJson.isspol_n1"
                  type="float"
                  required
                ></b-form-input>
              </div>
              <div class="col">
                <span>Precio Particular</span>
                <b-form-input
                  id="precparticular"
                  @keypress="soloNumeros"
                  v-model="itemOdontologico.precioJson.particular"
                  type="float"
                  required
                ></b-form-input>
              </div>
            </div>
            <hr />
            <span>Estados (Activos / Inactivos)</span>
            <div class="row mt-1">
              <div class="col">
                <span>Iess</span>
                <b-form-checkbox
                  id="active-iess"
                  v-model="itemOdontologico.estadoJson.iess"
                  switch
                ></b-form-checkbox>
              </div>
              <div class="col">
                <span>Isspol</span>
                <b-form-checkbox
                  id="active-isspol"
                  v-model="itemOdontologico.estadoJson.isspol"
                  switch
                ></b-form-checkbox>
              </div>
              <div class="col">
                <span>Issfa</span>
                <b-form-checkbox
                  id="active-issfa"
                  v-model="itemOdontologico.estadoJson.issfa"
                  switch
                ></b-form-checkbox>
              </div>
              <div class="col">
                <span>Particular</span>
                <b-form-checkbox
                  id="active-particular"
                  v-model="itemOdontologico.estadoJson.particular"
                  switch
                ></b-form-checkbox>
              </div>
            </div>
            <hr />

            <span>Establecimientos</span>
            <div class="row mt-1 estab-grid">
              <div
                v-for="est in establecimientosEstado"
                :key="est.value"
                class="col-6 mb-2"
              >
                <div class="estab-item">
                  <span class="estab-label">{{ est.text }}</span>
                  <b-form-checkbox
                    v-model="est.activo"
                    switch
                    class="mb-0"
                  />
                </div>
              </div>
            </div>
            <hr />

            <b-form-group label-for="especialidad">
              <label>Especialidad: <span class="text-danger">*</span></label>
              <validation-provider
                #default="{ errors }"
                name="especialidad"
                rules="required"
              >
                <v-select
                  id="especialidad"
                  v-model="itemOdontologico.especialidad"
                  placeholder="Buscar por especialidad."
                  :options="especialidades"
                  :reduce="(option) => option.value"
                  label="text"
                  class="d-inline-block w-100"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-button type="submit" class="float-right mt-2" variant="primary"
              >Guardar</b-button
            >
            <!-- <b-button @click="salir()"  variant="danger">Salir</b-button> -->
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import { comprobarPermisos } from "@/shared/helpers";
import vSelect from "vue-select";
import actions from "../../assets/utils/utils";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BFormCheckbox,
  BFormTextarea,
} from "bootstrap-vue";

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormTextarea,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  data() {
    return {
      tituloEditar: null,
      especialidades: [],
      establecimientos: [],
      establecimientosEstado: [],
      itemOdontologico: {
        id: "",
        token: "",
        descripcion: "",
        codigo: "",
        precio: 0,
        especialidad: "",
        establecimiento: "",
        especialidades: [],
        establecimientos: [],
        estado: 1,
        precioJson: {
          issfa_n1: 0,
          issfa_n2: 0,
          iess_n1: 0,
          particular: 0,
          isspol_n1: 0,
        },
        estadoJson: {
          iess: true,
          isspol: true,
          issfa: true,
          particular: true,
        },
      },
    };
  },

  props: {
    tokenSeleccionado: {
      default: null,
      required: false,
    },
  },
  created() {
    this.fetchEspecialidades();
    this.fetchEstablecimientos();
    //comprobarPermisos(this.$route);
  },
  watch: {
    tokenSeleccionado: {
      immediate: true,
      deep: true,
      async handler(newValue) {
        this.fetchitemOdontologico(newValue);
        if (!newValue) {
          actions.setearTitulo("Crear Item Odontologico");
        } else {
          this.tituloEditar = "Editar Item Odontologico";
        }
      },
    },
  },
  methods: {
    soloNumeros(event) {
      const char = String.fromCharCode(event.keyCode || event.which);
      const isNumberOrDot = /^[0-9.]$/.test(char);

      // Solo permitir número o punto
      if (!isNumberOrDot) {
        event.preventDefault();
      }

      // Opcional: evitar más de un punto
      const input = event.target;
      if (char === "." && input.value.includes(".")) {
        event.preventDefault();
      }
    },
    // comprobarPermisos() {
    //   if (localStorage.getItem('permisos').indexOf('editar_itemOdontologico') === -1) {
    //     this.$router.push({ name: 'not-permitted' })
    //   }
    // },
    salir() {
      this.$router.push({ name: "consultar_cartera_procesoclinico" });
    },
    async fetchEstablecimientos() {
      const query = `
                        query {
                            allEstablecimientos {
                                id
                                Descripcion
                                uniCodigo
                            }
                        }
                    `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        this.establecimientos = response.data.data.allEstablecimientos.map(
          (item) => ({
            value: item.id,
            text: item.Descripcion,
            uniCodigo: item.uniCodigo,
          })
        );
        this.syncEstablecimientosEstado();
      } catch (error) {
        console.error("An error occurred while fetching the options:", error);
      }
    },
    async fetchEspecialidades() {
      const query = `
                        query {
                            allEspecialidad {
                                id
                                descripcion
                            }
                        }
                    `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        this.especialidades = response.data.data.allEspecialidad.map(
          (item) => ({
            value: item.id,
            text: item.descripcion,
          })
        );
      } catch (error) {
        console.error("An error occurred while fetching the options:", error);
      }
    },

    async submitForm() {
      const query = `
        mutation actualizarItemOdontologico($odontoDatos: odontoInputUpdate!) {
  actualizarItemOdontologico(odontoDatos: $odontoDatos) {
    itemOdontoActualizado {
      token
      
      codigo
      descripcion
      establecimiento
      especialidad {
        id
        descripcion
      }
      precio
      estado
      precioJson
      estadoJson
    }
    status
    message
  }
}
        `;

      const user = JSON.parse(localStorage.getItem("detalleusuario"));
      let idEstablecimiento = user.establecimiento
        ? user.establecimiento.id
        : "";

      const variables = {
        odontoDatos: {
          token: this.itemOdontologico.token,
          datos: {
            codigo: this.itemOdontologico.codigo,
            precioJson: JSON.stringify(this.itemOdontologico.precioJson),
            estadoJson: JSON.stringify(this.itemOdontologico.estadoJson),
            descripcion: this.itemOdontologico.descripcion,
            establecimiento: this.establecimientosEstado
              .filter((e) => e.activo)
              .map((e) => e.value)
              .join(","),
            especialidad: this.itemOdontologico.especialidad.value
              ? this.itemOdontologico.especialidad.value
              : this.itemOdontologico.especialidad,
          },
        },
      };
      console.log(variables);

      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });

        if (
          response.data.data.actualizarItemOdontologico.status === "success"
        ) {
          await this.$swal({
            icon: "success",
            title: "Éxito",
            text: "La itemOdontologico se actualizó correctamente.",
          });
          this.$router.push({ name: "consultar_cartera_odontologia" });
        } else {
          throw new Error(
            response.data.data.actualizarItemOdontologico.message
          );
        }
      } catch (error) {
        await this.$swal({
          icon: "error",
          title: "Error",
          text:
            error.message ||
            "Hubo un problema al actualizar la itemOdontologico.",
        });
      }
    },
    async fetchitemOdontologico(tokenitemOdontologico) {
      const query = `query GetitemOdontologico($tokenproc: String!) {
                allOdonto(tokenproc: $tokenproc) {
                    total
                    status
                    message
                    itemOdontologico{
                        id
                        token
                        descripcion
                        
                        establecimiento
                      	especialidad {
                          id
                          descripcion
                        }
                        codigo
                        estado
                        precio
                        precioJson
                        estadoJson
                    }
                   
                }
            }
        `;

      const variables = {
        tokenproc: tokenitemOdontologico,
      };

      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });

        if (response.data.data.allOdonto.status === "Success") {
          if (response.data.data.allOdonto.itemOdontologico) {
            console.log(
              "itemOdontologico:",
              response.data.data.allOdonto.itemOdontologico[0]
            );
            const proc = response.data.data.allOdonto.itemOdontologico[0];
            let precioJson = this.itemOdontologico.precioJson;
            if (proc.precioJson) {
              try {
                precioJson = JSON.parse(proc.precioJson);
              } catch (error) {
                console.log("error precio json", error);
              }
            }
            let estadoJson = this.itemOdontologico.estadoJson;
            if (proc.estadoJson) {
              try {
                estadoJson = JSON.parse(proc.estadoJson);
              } catch (error) {
                console.log("error estado json", error);
              }
            }
            this.itemOdontologico = {
              token: proc.token,
              descripcion: proc.descripcion,
              codigo: proc.codigo,
              precio: proc.precio,
              especialidad: {
                value: proc.especialidad.id,
                text: proc.especialidad.descripcion,
              },
              establecimiento: proc.establecimiento,
              estado: proc.estado,
              precioJson: precioJson,
              estadoJson: estadoJson,
            };
            this.syncEstablecimientosEstado();
            console.log("this.itemOdontologico", this.itemOdontologico);
          }
        } else {
          console.error(
            "Error al obtener la itemOdontologico:",
            response.data.message
          );
        }
      } catch (error) {
        console.error("Error al realizar la consulta GraphQL:", error);
      }
    },
    syncEstablecimientosEstado() {
      const ids = (this.itemOdontologico.establecimiento || "")
        .toString()
        .split(",")
        .map((i) => i.trim())
        .filter(Boolean);
      this.establecimientosEstado = (this.establecimientos || []).map((est) => ({
        ...est,
        activo: ids.includes(String(est.value)),
      }));
    },
  },
};
</script>

<style>
/* Estilos personalizados si son necesarios */
.estab-grid .col-6 {
  padding-left: 8px;
  padding-right: 8px;
}

.estab-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  background: #f9fbff;
  min-height: 38px;
}

.estab-label {
  font-weight: 600;
  font-size: 0.9rem;
  color: #344050;
}
</style>
